module.exports = __webpack_public_path__ + "img/housing_3.2b84fab3.jpg";